import { Link } from "gatsby";
import React, { useEffect, useState } from "react";
import ReviewStars from "./ReviewStars";
import { useLocation } from "@reach/router";
import { linkFormat } from "../../utilities/linkFormat";

export default function ProductReviewStars({ product, link }) {
  const [reviews, setReviews] = useState(null);
  const [totalReviews, setTotalReviews] = useState(null);
  const [rating, setRating] = useState(null);
  const [fixedRating, setFixedRating] = useState(null);
  const location = useLocation();

  const linkTo = link ? link : `${location.pathname}#reviews`;

  const bazaarId = product.productMetafields.find(
    (field) => field.key === "extId" && field.namespace === "bazaar_voice"
  );

  const url = !bazaarId
    ? null
    : `//api.bazaarvoice.com/data/statistics.json?apiversion=5.4&passkey=drvgwonih7es3o3b0v3g0f9m4&stats=Reviews&filter=ContentLocale:en_US&filter=ProductId:${bazaarId.value}`;

  useEffect(() => {
    url &&
      fetch(url)
        .then((res) => res.json())
        .then((res) => {
            if (res.Results[0]) {
              const productStats = res.Results[0].ProductStatistics
              const reviewStats = productStats.ReviewStatistics
              setReviews(productStats)
              setTotalReviews(reviewStats.TotalReviewCount)
              setRating(reviewStats.AverageOverallRating)
            }
        });
  }, [url]);

  useEffect(() => {
    if(rating) {
      setFixedRating(rating.toFixed(1))
    }
  }, [rating])

  if (!reviews) {
    return null;
  }

  return (
    <Link to={linkFormat(linkTo)}>
      <button
        aria-label={`${fixedRating} out of 5 stars. Read reviews for average rating value is ${fixedRating} of 5. Read ${totalReviews} Reviews`}
        className="product-review-stars flex items-center text-primary-dark"
      >
        <ReviewStars
          rating={fixedRating}
          starSize={"18px"}
          starSpacing={"1px"}
          totalReviews={totalReviews}
        />
        {rating && (
          <div className="product-review-stars__rating-container flex items-center text-xs sm:ml-xs">
            <span className="mr-1">{fixedRating}</span>
            <span className="product-review-stars__total-reviews">({totalReviews})</span>
          </div>
        )}
      </button>
    </Link>
  );
}
